<template>
  <div>
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'report-one' }">
        {{ $t("HomePage.HomePage") }}
        <!-- Dashboard -->
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        {{ $t("ShopRatingDetails.ShopRating") }}
        <!-- คะแนนร้านค้า  -->
      </b-breadcrumb-item>
    </b-breadcrumb>

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>
              {{ $t("ShopRatingDetails.Show") }}
              <!-- แสดง -->
            </label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>
              {{ $t("ShopRatingDetails.Entries") }}
              <!-- รายการ -->
            </label>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative fix-minHeight-table"
        :items="fetchUsers"
        responsive
        :fields="tableColumns_i18n"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('HomePage.NoMatching')"
        :sort-desc.sync="isSortDirDesc"
      >

        <template #cell(index)="data">
          <div style="text-align: center;">
            {{ (currentPage - 1) * perPage + data.index + 1 }}
            </div>
        </template>
        <!-- Column: User -->
        <template #cell(response)="data">
          <b-button
            v-if="data.item.replies.length == 0"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            @click="handlerShowModal(data.item.id)"
            variant="outline-primary"
          >
            ตอบกลับ
          </b-button>
          <b-button
            v-else
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-success"
          >
            ตอบกลับแล้ว
          </b-button>
        </template>

        <!-- Column: Role -->
        <template #cell(contactType)="data">
          <div class="text-nowrap">
            <feather-icon
              :icon="resolveUserRoleIcon(data.item.contactType)"
              size="18"
              class="mr-50"
              :class="`text-${resolveUserRoleVariant(data.item.contactType)}`"
            />
            <span class="align-text-top text-capitalize">{{
              data.item.contactType
            }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(active)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.active)}`"
            class="text-capitalize"
          >
            {{ data.item.active ? "Active" : "Inactive" }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              :to="{
                name: 'member-view',
                params: { id: data.item.contactId },
              }"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">
                {{ $t("ShopRatingDetails.ViewInformation") }}
                <!-- ดูข้อมูล -->
              </span>
            </b-dropdown-item>

            <b-dropdown-item
              :to="{
                name: 'member-view',
                params: { id: data.item.contactId, isEdit: true },
              }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">
                {{ $t("ShopRatingDetails.Edit") }}
                <!-- แก้ไข -->
              </span>
            </b-dropdown-item>

            <!-- <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item> -->
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">
              {{ $t("ShopRatingDetails.Showing") }}
              <!-- Showing -->
              {{ dataMeta.from }}
              {{ $t("ShopRatingDetails.to") }}
              <!-- to -->
              {{ dataMeta.to }}
              {{ $t("ShopRatingDetails.of") }}
              <!-- of -->
              {{ dataMeta.of }}
              {{ $t("ShopRatingDetails.Entries") }}
              <!-- entries -->
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal id="modal-center" centered title="Status" ok-only ok-title="Save">
      <b-form-group>
        <v-select
          v-model="selected"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="title"
          :options="option"
        />
      </b-form-group>
    </b-modal>

    <b-modal
      id="modal-center-response"
      ref="modal-center-response"
      centered
      title="ตอบกลับความคิดเห็น"
      ok-only
      ok-title="ยืนยัน"
      @ok="handlerAddReply"
    >
      <b-form-group label="ข้อความตอบกลับ" label-for="basicInput">
        <b-form-input id="basicInput" v-model="comment" />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BBreadcrumb,
  BBreadcrumbItem,
  BModal,
  VBModal,
  BFormGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import UsersListFilters from "./pointShopComponents/MembersListFilters.vue";
import useUsersList from "./pointShopComponents/usePointShopList";
import userStoreModule from "./pointShopStoreModule";
import UserListAddNew from "./pointShopComponents/MemberListAddNew.vue";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    UsersListFilters,
    UserListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BBreadcrumb,
    BBreadcrumbItem,
    vSelect,
    BModal,
    BFormGroup,
    ToastificationContent,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      selected: { title: "Active" },

      option: [{ title: "Active" }, { title: "Inactive" }],
      comment: "",
      reviewId: "",
    };
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "point-shop";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    // onUnmounted(() => {
    //   if (store.hasModule(USER_APP_STORE_MODULE_NAME))
    //     store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    // });

    const isAddNewUserSidebarActive = ref(false);

    const roleOptions = [
      { label: "Admin", value: "admin" },
      { label: "Author", value: "author" },
      { label: "Editor", value: "editor" },
      { label: "Maintainer", value: "maintainer" },
      { label: "Subscriber", value: "subscriber" },
    ];

    const planOptions = [
      { label: "All", value: "" },
      { label: "Seller", value: "Seller" },
      { label: "Buyer", value: "Buyer" },
    ];

    const statusOptions = [
      { label: "All", value: "" },
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ];

    const {
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useUsersList();

    return {
      // Sidebar
      isAddNewUserSidebarActive,

      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    };
  },

  computed: {
    tableColumns_i18n() {
      return [
        { key: 'index',
        label: this.$t('ShopRatingDetails.Number')
        },
        {
          key: "reviewerName",
          label: this.$t("ShopRatingDetails.Username"),
          sortable: true,
        },
        {
          key: "orderNo",
          label: this.$t("ShopRatingDetails.OrderNumber"),
          sortable: true,
        },
        {
          key: "productName",
          label: this.$t("ShopRatingDetails.ProductName"),
          sortable: true,
        },
        {
          key: "rating",
          label: this.$t("ShopRatingDetails.Quantity"),
          sortable: true,
        },
        {
          key: "comment",
          label: this.$t("ShopRatingDetails.ReviewDetails"),
          sortable: true,
        },        {
          key: "createdOnForDate",
          label: this.$t("ShopRatingDetails.ReviewDate"),
          sortable: true,
        },
        {
          key: "response",
          label: this.$t("ShopRatingDetails.Response"),
          sortable: true,
        },
      ];
    },
  },
  //   // Table Handlers
  // const tableColumns = [
  //   { key: 'reviewerName', label: 'ชื่อผู้ใช้', sortable: true },
  //   { key: 'orderNo', label: 'เลข Order', sortable: true },
  //   { key: 'productName', label: 'รายละเอียดสินค้า', sortable: true },
  //   { key: 'supportCount', label: 'จำนวน', sortable: true },
  //   { key: 'rating', label: 'รายละเอียดการรีวิว', sortable: true },
  //   { key: 'response', label: "การตอบกลับ", sortable: true },

  // ]
  mounted() {},
  methods: {
    showToast(variant, icon, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon,
          text,
          variant,
        },
      });
    },
    handlerShowModal(reviewId) {
      this.reviewId = reviewId;
      this.$refs["modal-center-response"].show();
    },
    handlerAddReply(reviewId) {
      let payload = {
        reviewId: this.reviewId,
        toReplyId: null,
        comment: this.comment,
        isAnonymous: true,
      };
      store
        .dispatch("point-shop/addReply", payload)
        .then((response) => {
          console.log("response");
          this.fetchUsers();
          this.refetchData()
        })
        .catch((error) => {
          console.log("err", error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.fix-minHeight-table {
  min-height: 15rem;
}
</style>
